// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"43768d4e","908":"c7d9c835","925":"af9d0837"}[chunkId] + ".chunk.js";
};